module.exports = __webpack_public_path__ + "static/media/Logo.e061b27e.svg";